import type { TimeRangeFinite, AllocationObj } from "types/types";
import { useDispatch } from "react-redux";
import useQueryWithErrorHandling from "utils/useQuery";
import { FETCH_POLICY } from "segments/AggregatesGetter/aggregatesGetterUtils";
import { ALLOCATION_LIST_QUERY } from "providers/MidgardProvider";
import { updateAllocationList } from "providers/GlobalStateProvider";
import useGetIsMounted from "utils/useGetIsMounted";
import { ALLOCATION_LIST_QUERY_TITLE } from "contexts/ErrorManager/errorManagerUtils";
import { useTransition } from "react";

type queryAllocationListProps = {
  skip?: boolean;
  client: any;
  onError: any;
  variables: any;
  timeRange: TimeRangeFinite | null;
  pollInterval?: number | null;
  initialPollInterval: number;
  setPollInterval: any;
};

export function useQueryAndUpdateAllocationList({
  skip = false,
  variables,
  timeRange,
  client,
  pollInterval = null,
  initialPollInterval,
  onError,
  setPollInterval,
}: queryAllocationListProps) {
  const dispatch = useDispatch();
  const getIsMounted = useGetIsMounted();
  const [, startTransition] = useTransition();
  const { error, loading } = useQueryWithErrorHandling(
    ALLOCATION_LIST_QUERY_TITLE,
    ALLOCATION_LIST_QUERY,
    {
      skip,
      ...(pollInterval ? { pollInterval } : {}),
      client,
      variables,
      fetchPolicy: FETCH_POLICY,
      onError,
      onCompleted: data => {
        if (
          getIsMounted() &&
          !skip &&
          data?.allocationList &&
          !loading &&
          !error
        ) {
          startTransition(() => {
            const allocationList = formatAllocationObj(data.allocationList);
            dispatch(updateAllocationList(allocationList));
            setPollInterval(initialPollInterval);
          });
        }
      },
    }
  );
}

function formatAllocationObj(allocationList: any[]): AllocationObj[] {
  return allocationList.map(allocationObj => {
    return {
      ...allocationObj,
      range: {
        ge: parseInt(allocationObj.ge, 10),
        lt: parseInt(allocationObj.lt, 10),
      },
      numberOfMinutes: parseInt(allocationObj.numberOfMinutes, 10),
    };
  });
}
